import React from "react";
import SurveyStatusPage from "../components/question-components/survey-status";

const Success = () => {
  return <SurveyStatusPage status="success" />;
};

export default Success;
